import "./AuthButton.css";
import { useNavigate } from "react-router-dom";

function LoginButton() {
  const navigate = useNavigate();
  return (
    <button className="auth-button" onClick={() => navigate("/login")}>
      Log In
    </button>
  );
}

export default LoginButton;
